import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ListeComponent } from 'src/app/liste/liste.component';
import { RechercheComponent } from 'src/app/recherche/recherche.component';
import { DateService } from 'src/app/services/date.service';
import { GeneralService } from 'src/app/services/general.service';
declare var Chart: any;
@Component({
  selector: 'app-ticket-list',
  templateUrl: './ticket-list.component.html',
  styleUrls: ['./ticket-list.component.scss'],
})
export class TicketListComponent implements OnInit {
  constructor(
    private router: Router,
    public generalService: GeneralService,
    private dateService: DateService
  ) { }
  dateDebut = new Date();
  dateFin = new Date();
  Tiers_code;
  montant;
  imageDomain = this.generalService.imageDomain;
  banques = this.generalService.banques;
  CashR_Type = [];
  totalTicket: number;
  numTicketDebut;
  numTicketFin;
  columnsArticle;
  columnsClient;
  columns;
  liste = [];
  exist = true;
  columnsTicket = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Site_Code1',
        Lg_Code: '',
        TableRD_Des: 'Etablissement',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Art_Des',
        Lg_Code: '',
        TableRD_Des: 'Article(s)',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Cash_Code',
        Lg_Code: '',
        TableRD_Des: 'Caisse',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 7,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'etat',
        Lg_Code: '',
        TableRD_Des: 'État',
        TableRD_Largeur: 80,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 8,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'CashD_Id',
        Lg_Code: '',
        TableRD_Des: 'N°clôture',
        TableRD_Largeur: 110,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Num',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Date',
        Lg_Code: '',
        TableRD_Des: 'Date',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_RS',
        Lg_Code: '',
        TableRD_Des: 'Client',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'DocCashD_PTTC',
        Lg_Code: '',
        TableRD_Des: 'T.HT',
        TableRD_Largeur: 90,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 2,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'DocCashD_TxRem',
        Lg_Code: '',
        TableRD_Des: 'T.TTC',
        TableRD_Largeur: 90,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 2,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  listeTicket = [];
  listeTicketBrut = [];
  selectedClient;
  selectedArticle;
  selectedEtablissement;
  selectedCaisson;
  selectedCaisse;
  listeArticle = [];
  listeClient = [];
  listeEtablissement = [];
  listeCaisson = [];
  listeCaisse = [];
  listBtn: Array<any> = [
    { name: 'choisir', class: 'colorGreen', text: 'Choisir', icon: 'mouse' },
    { name: 'fermer', class: 'colorRed', text: 'Fermer', icon: 'close' },
  ];
  titreFrmRecherche = '';
  @ViewChild('frmStatistique', { static: false }) frmStatistique;
  @ViewChild('article', { static: false }) article: RechercheComponent;
  @ViewChild('client', { static: false }) client: RechercheComponent;
  @ViewChild('myCanvas') myCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('myCanvas2') myCanvas2: ElementRef<HTMLCanvasElement>;
  @ViewChild('listeTicketsComponent', { static: false })
  listeTicketsComponent: ListeComponent;
  @ViewChild('listeConmponent', { static: false })
  listeConmponent: ListeComponent;
  @ViewChild('statistiqueConmponent', { static: false })
  statistiqueConmponent: ListeComponent;
  customFooter = {
    listeFooter: [{ colonne: [] }],
  };
  customFooterStatistique = {
    style: { 'background-color': '#d4d4d4' },
    listeFooter: [{ colonne: [] }],
  };
  listeStatistique = [];
  columnsStatistique = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'articleVendeur',
        Lg_Code: '',
        TableRD_Des: 'Statistique vendeur/article',
        TableRD_Largeur: 250,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 7,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'total',
        Lg_Code: '',
        TableRD_Des: 'Total',
        TableRD_Largeur: 90,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'nbrArticle',
        Lg_Code: '',
        TableRD_Des: 'Nb.Artiqules',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'nbrTicket',
        Lg_Code: '',
        TableRD_Des: 'Nb.Tickets',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'remise',
        Lg_Code: '',
        TableRD_Des: 'Remise',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  ngOnInit(): void {
    this.initCutemFooter();
    this.selectedClient = {};
    this.selectedCaisse = {};
    this.selectedArticle = {};
    this.selectedEtablissement;
    this.selectedCaisson = {};

    this.getColonneArticle();
    this.getColonneClient();
    this.getListeArticle();
    this.getListeClient();

    this.getListeCaisse();
    this.getListeVendeur();
    // this.generalService.rechercheTable('DiverSys', 'trpos').subscribe((res) => {
    //   this.generalService.CashR_Type = res;
    //   console.log(res);

    // });
  }
  selectionChange(event) {
    if (this.article.selectedRow)
      this.selectedArticle = this.article.selectedRow;
    else this.selectedArticle = {};
  }
  selectionClientChange($event) {
    if (this.client.selectedRow) this.selectedClient = this.client.selectedRow;
    else this.selectedClient = {};
  }
  initCutemFooter() {
    this.columnsTicket.TableRD.forEach((col) => {
      this.customFooter.listeFooter[0].colonne.push({
        name: col.TableRD_Champs,
        text: '',
        style: {
          'text-align': 'right',
          'font-weight': 'bold',
          width: col.TableRD_Largeur + 'px',
        },
      });
    });
    this.columnsStatistique.TableRD.forEach((col) => {
      this.customFooterStatistique.listeFooter[0].colonne.push({
        name: col.TableRD_Champs,
        text: '',
        style: { 'font-weight': 'bold', width: col.TableRD_Largeur + 'px' },
      });
    });
  }
  getListeCaisse() {
    this.generalService
      .rechercheTable(this.generalService.url + 'Cash')
      .subscribe((data) => {
        this.listeCaisse = data;
        this.listeEtablissement = this.generalService.distinct(
          this.listeCaisse,
          'Site_Code'
        );
      });
  }
  getListeVendeur() {
    this.generalService
      .rechercheTable(this.generalService.url + 'avtperso&param=0')
      .subscribe((data) => {
        this.listeCaisson = data;
      });
  }
  getListeClient() {
    this.generalService
      .rechercheTable(this.generalService.url + 'client')
      .subscribe((data) => {
        this.listeClient = data;
      });
  }
  getListeArticle() {
    this.generalService
      .rechercheTable(this.generalService.url + 'article')
      .subscribe((data) => {
        this.listeArticle = data;
      });
  }
  getColonneArticle() {
    this.generalService
      .rechercheTable('recherche/TbRecherche?param=article')
      .subscribe((data) => {
        this.columnsArticle = data;
      });
  }
  getColonneClient() {
    this.generalService
      .rechercheTable('recherche/TbRecherche?param=client')
      .subscribe((data) => {
        this.columnsClient = data;
      });
  }
  clearSelectedArticle() {
    this.selectedArticle = {};
  }
  clearSelectedClient() {
    this.selectedClient = {};
  }
  openFrmRecherche(frmListe, frm) {
    if (frm == 'article') {
      this.titreFrmRecherche = '<h4>Liste articles</h4>';
      this.columns = this.columnsArticle;
      this.liste = this.listeArticle;
    } else {
      this.titreFrmRecherche = '<h4>Liste client</h4>';
      this.columns = this.columnsClient;
      this.liste = this.listeClient;
    }
    this.generalService.dialogOpend = this.generalService.dialog.open(
      frmListe,
      { width: '85vw', height: '70vh' }
    );
    this.generalService.dialogOpend.afterClosed().subscribe((result) => {
      if (this.listeConmponent.row) {
        if (frm == 'article') this.selectedArticle = this.listeConmponent.row;
        else this.selectedClient = this.listeConmponent.row;
      }
    });
  }
  blurArticle(Art_Code) {
    this.selectedArticle.Art_Code = Art_Code;
  }
  goToTicket() {
    this.router.navigate(['/avt/caisse']);
  }
  recherche() {
    if (
      this.generalService.isNotEmpty(this.dateDebut) &&
      this.generalService.isNotEmpty(this.dateFin)
    ) {
      this.exist = false;
      var param =
        this.dateService.setFormatDateRechercheServer(this.dateDebut) +
        ',' +
        this.dateService.setFormatDateRechercheServer(this.dateFin);
      param += ',' + (this.numTicketDebut ? this.numTicketDebut : '');
      param +=
        ',' +
        (this.selectedArticle && this.selectedArticle.Art_Code
          ? this.selectedArticle.Art_Code
          : '');
      param +=
        ',' +
        (this.selectedClient && this.selectedClient.Tiers_Code
          ? this.selectedClient.Tiers_Code
          : '');
      param +=
        ',' +
        (this.selectedEtablissement && this.selectedEtablissement != '-1'
          ? this.selectedEtablissement
          : '');
      param +=
        ',' +
        (this.selectedCaisse.Cash_Code && this.selectedCaisse.Cash_Code != '-1'
          ? this.selectedCaisse.Cash_Code
          : '');
      param +=
        ',' +
        (this.selectedCaisson.Perso_Matricule &&
          this.selectedCaisson.Perso_Matricule != '-1'
          ? this.selectedCaisson.Perso_Matricule
          : '');
      this.generalService
        .rechercheTable('recherche/tbdata?tablere=DocCacshJou&param=' + param)
        .subscribe((data) => {
          this.listeTicketBrut = data;
          console.log(data);
          this.listeTicket = this.formaterData(data);
          setTimeout(() => {
            if (data.length != 0) {
              this.calculerTotal();
            }
            else {
              this.exist = true;
              this.generalService.dialogSuccess(
                'Pas de données',
                false
              );
            }
          }, 100);
        });
    }
  }
  formaterData(data) {
    var liste = [];
    var distinctDocNum = this.generalService.distinct(data, 'Doc_Num');
    distinctDocNum.forEach((docNum) => {
      var lst = data.filter((d) => {
        return d.Doc_Num == docNum;
      });
      var row = data.find((d) => {
        return d.Doc_Num == docNum;
      });
      liste.push({
        Site_Code: row.Site_Code,
        etat: 'lock',
        Cash_CodeText:
          "<b style='color: blue;' > <i class='fas fa-search'></i> " +
          row.Cash_Code +
          '</b>',
        Cash_Code: row.Cash_Code,
        Doc_Num: row.Doc_Num,
        Doc_Date: row.Doc_Date,
        CashD_Id: row.CashD_Id,
        Doc_RS: row.Doc_RS,
        Doc_THT: row.Doc_THT,
        Doc_TTTC: row.Doc_TTTC,
        article: lst.reduce((a, b) => a + b.Art_Des + ', ', ''), //.
        DocCashD: lst,
      });
    });
    return liste;
  }
  calculerTotal() {
    this.selectedArticle.total = 0;
    this.selectedArticle.nbrArticle = 0;
    var listeTicket = this.listeTicketsComponent.getDataSource();
    listeTicket = this.listeTicketsComponent.getDataSource();
    this.totalTicket = listeTicket.reduce((a, b) => a + b.Doc_TTTC, 0);
    this.exist = true;
    listeTicket.forEach((ticket) => {
      var lst = ticket.DocCashD;
      if (this.selectedArticle.Art_Code)
        lst = ticket.DocCashD.filter((art) => {
          return art.Art_Code == this.selectedArticle.Art_Code;
        });
      this.selectedArticle.total += lst.reduce(
        (a, b) => a + b.DocCashD_PTTC,
        0
      );
      this.selectedArticle.nbrArticle += lst.length;
    });
    var lst = listeTicket;
    if (this.selectedClient.Tiers_code)
      lst = listeTicket.filter((ticket) => {
        return ticket.Tiers_code == this.selectedClient.Tiers_code;
      });
    // this.selectedClient.total = lst.reduce((a,b) => a+b.Doc_TTTC,0);
    // this.selectedClient.nbrClient = lst.length
    this.CashR_Type.forEach((type) => {
      type.total = 0;
      listeTicket.forEach((ticket) => {
        type.total += ticket.DocCashD.reduce(
          (a, b) => a + b.DocCashR_Montant,
          0
        );
      });
    });
    this.customFooter.listeFooter[0].colonne.find((col) => {
      return col.name == 'Doc_TTTC';
    }).text = 'T.TTC ' + this.totalTicket;
    this.customFooter.listeFooter[0].colonne.find((col) => {
      return col.name == 'Doc_THT';
    }).text = 'T.HT ' + listeTicket.reduce((a, b) => a + b.Doc_THT, 0);
  }
  clearNumTicketDebut() {
    this.numTicketDebut = '';
  }
  clearNumTicketFin() {
    this.numTicketFin = '';
  }
  output(event) {
    if (
      event.action == 'clickColonne' &&
      event.colonne.TableRD_Champs == 'Cash_CodeText'
    ) {
      this.generalService.dialogOpend = this.generalService.dialog.open(
        this.frmStatistique,
        { width: '95vw', height: '70vh' }
      );
      setTimeout(() => {
        this.drawChart(event.liste.row.Cash_Code);
      }, 100);
    }
    if (event.action == 'clickRow') {
      this.getdsDocCash(this.listeTicketsComponent.row.Doc_Num);
    }
    if (event.action == 'filterData') {
      this.calculerTotal();
    }
  }
  setChartByCaissant(liste) {
    var ctx = this.myCanvas.nativeElement.getContext('2d');
    var dataToShow = [];
    var listeLabel = [];
    var listColor = [];
    this.listeCaisson.forEach((caisson) => {
      var filtredListe = liste.filter((lst) => {
        return lst.Rep_Code == caisson.Perso_Matricule;
      });
      if (filtredListe.length > 0) {
        listeLabel.push(caisson.Perso_Nom);
        var n =
          'rgb(' +
          this.getRandom() +
          ',' +
          this.getRandom() +
          ',' +
          this.getRandom() +
          ')';
        listColor.push(n);
        dataToShow.push(
          filtredListe.reduce((a, b) => {
            return a + b.Doc_TTTC;
          }, 0)
        );
      }
    });
    var data = {
      labels: listeLabel,
      datasets: [
        {
          data: dataToShow,
          backgroundColor: listColor,
        },
      ],
    };
    var config = {
      type: 'pie',
      data: data,
      options: {
        plugins: {
          legend: { position: 'right' },
          title: { text: 'Statistique par vendeurs', display: true },
        },
      },
    };
    var myChart = new Chart(ctx, config);
  }
  setChartByArticle(liste) {
    var dataToShow2 = [];
    var listeLabel2 = [];
    var listColor2 = [];
    var listeArticleDistinct = this.generalService.distinct(liste, 'Art_Code');
    listeArticleDistinct.forEach((artCode) => {
      var filtredListe = liste.filter((lst) => {
        return lst.Art_Code == artCode;
      });
      listeLabel2.push(filtredListe[0].Art_Des);
      var n =
        'rgb(' +
        this.getRandom() +
        ',' +
        this.getRandom() +
        ',' +
        this.getRandom() +
        ')';
      listColor2.push(n);
      dataToShow2.push(
        filtredListe.reduce((a, b) => {
          return a + b.Doc_TTTC;
        }, 0)
      );
    });
    var data2 = {
      labels: listeLabel2,
      datasets: [
        {
          data: dataToShow2,
          backgroundColor: listColor2,
          //   'rgb(255, 99, 132)',
        },
      ],
    };
    var config2 = {
      type: 'pie',
      data: data2,
      options: {
        plugins: {
          legend: { position: 'right' },
          title: { text: 'Statistique par article', display: true },
        },
      },
    };
    var ctx2 = this.myCanvas2.nativeElement.getContext('2d');
    var myChart2 = new Chart(ctx2, config2);
  }
  drawChart(Cash_Code) {
    var liste = this.listeTicketBrut.filter((ticket) => {
      return ticket.Cash_Code == Cash_Code;
    });
    this.setChartByCaissant(liste);
    this.setChartByArticle(liste);
    this.genererListeStatistique(liste);
  }
  genererListeStatistique(liste) {
    this.listeStatistique = [];
    this.listeStatistique.push({
      articleVendeur: '<b>Vendeur</b>',
      total: null,
      nbrArticle: null,
      nbrTicket: null,
      remise: null,
    });
    this.listeCaisson.forEach((caisson) => {
      var filtredListe = liste.filter((lst) => {
        return lst.Rep_Code == caisson.Perso_Matricule;
      });
      if (filtredListe.length > 0) {
        this.listeStatistique.push({
          articleVendeur:
            "<span style='margin-left : 10px'>" + caisson.Perso_Nom + '</span>',
          total: filtredListe.reduce((a, b) => {
            return a + b.Doc_TTTC;
          }, 0),
          nbrArticle: this.generalService.distinct(filtredListe, 'Art_Code')
            .length,
          nbrTicket: this.generalService.distinct(filtredListe, 'Doc_Num')
            .length,
          remise: filtredListe.reduce((a, b) => {
            return a + b.DocCashD_Rem;
          }, 0),
        });
      }
    });
    this.listeStatistique.push({
      articleVendeur: '<b>Article</b>',
      total: null,
      nbrArticle: null,
      nbrTicket: null,
      remise: null,
    });
    var listeArticleDistinct = this.generalService.distinct(liste, 'Art_Code');
    listeArticleDistinct.forEach((artCode) => {
      var filtredListe = liste.filter((lst) => {
        return lst.Art_Code == artCode;
      });
      this.listeStatistique.push({
        articleVendeur:
          "<span style='margin-left : 10px'>" +
          filtredListe[0].Art_Des +
          '</span>',
        total: filtredListe.reduce((a, b) => {
          return a + b.Doc_TTTC;
        }, 0),
        nbrArticle: filtredListe.length,
        nbrTicket: this.generalService.distinct(filtredListe, 'Doc_Num').length,
        remise: filtredListe.reduce((a, b) => {
          return a + b.DocCashD_Rem;
        }, 0),
      });
    });
    this.customFooterStatistique.listeFooter[0].colonne.find((col) => {
      return col.name == 'total';
    }).text = this.listeStatistique.reduce((a, b) => {
      return a + b.total;
    }, 0);
    this.customFooterStatistique.listeFooter[0].colonne.find((col) => {
      return col.name == 'nbrArticle';
    }).text = this.listeStatistique.reduce((a, b) => {
      return a + b.nbrArticle;
    }, 0);
    this.customFooterStatistique.listeFooter[0].colonne.find((col) => {
      return col.name == 'nbrTicket';
    }).text = this.listeStatistique.reduce((a, b) => {
      return a + b.nbrTicket;
    }, 0);
    this.customFooterStatistique.listeFooter[0].colonne.find((col) => {
      return col.name == 'remise';
    }).text = this.listeStatistique.reduce((a, b) => {
      return a + b.remise;
    }, 0);
  }
  getRandom() {
    return parseInt((Math.random() * 256).toString()).toString();
  }
  outputArticle(event) {
    if (event.action == 'clickBtnHeat') {
      if (event.bouton.name == 'choisir') {
        if (this.listeConmponent.row) this.generalService.dialog.closeAll();
        else
          this.generalService.dialogSuccess(
            'Veuillez sélectionner une ligne',
            false
          );
      }
      if (event.bouton.name == 'fermer') this.generalService.dialog.closeAll();
    }
  }
  dsDocCash;
  getdsDocCash(Doc_Num) {
    this.generalService.getDS('DocCash', Doc_Num).subscribe((ds: any) => {
      this.dsDocCash = ds;
    });
  }
  async getCashRByIndex(index) {
    try {
      var reglement: any = this.generalService.getCashRByIndex(index);
      if (reglement) return reglement.DiverSys_Libelle;
      else return '';
    } catch (error) {
      return '';
    }
  }

  goToCaisse() {
    this.router.navigate(['/avt/caisse']);
  }
  close() {
    this.generalService.dialog.closeAll();
  }
}
